import PropTypes from "prop-types";
import classNames from "classnames";

const prefix = "t-form-control";

const FormControl = ({
  className,
  children,
  errors,
  fullwidth = true,
  label,
  labelProps: { className: lblClass, ...labelProps } = {},
  orientation = "horizontal",
  reverse = false,
  showErrors = true,
  wrapClass,
  ...props
}) => {
  
  const componentClass = classNames(prefix, "flex flex-wrap",  {
    "flex-row justify-end items-start gap-2": orientation === "horizontal",
    "flex-col gap-1": orientation === "vertical",
    "w-[100%]": fullwidth,
    "flex-row-reverse": reverse,
    [className]: className
  });

  const labelClass = classNames(`${prefix}__label h-[100%]`, {
    "text-red-700": !!errors,
    [lblClass]: lblClass,
    "flex flex-1": orientation === "vertical"
  });

  const inputClass = classNames("flex flex-wrap relative", {
    [wrapClass]: wrapClass,
    "flex flex-1": orientation === "vertical"
  });

  return (
    <div className={componentClass} {...props}>
      <label className={labelClass} {...labelProps}>
        {label}
      </label>
      <div className={inputClass}>
        {children}
      </div>

      {showErrors && !!errors  && <span className="text-red-700" >
        {(errors?.type === "is-valid-tld") && "Ingresa un correo corporativo"}
        {(errors?.type === "required") && "Es requerido"}
        {(errors?.type === "email") && "Se require un email válido"}
      </span>}
    </div>
  );
};

FormControl.propTypes = {
  fullwidth: PropTypes.bool,
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  reverse: PropTypes.bool,
  showErrors: PropTypes.bool
};

export default FormControl;
